<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homet' }" replace>首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/Wrong' }" replace>错题批改</el-breadcrumb-item>
				<el-breadcrumb-item>{{ type == 0 ? '待批改' : '已完成' }}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="p_m_t_30 p_flex" :style="{ height: height + 'px' }">
			<div class="p_f_1 deatil_content overflow" v-if="dataInfo.id">
				<div class="list_box p_b_b">
					<div id="" class="p_flex p_f_b">
						<div class="two-overflow type_size_22" v-html="dataInfo.question.title"></div>
						<div v-if="dataInfo.job_type == 2">
							<el-button type="warning" v-if="testShow" @click="testShow = false">查看试卷</el-button>
							<el-button type="warning" v-if="!testShow" @click="testShow = true">批改</el-button>
						</div>
					</div>
					<div class="p_flex p_f_a p_f_b p_m_t_20">
						<div class="p_flex p_f_1 one-overflow p_m_r_30">{{ dataInfo.jobPublish.name }}</div>
						<div class="p_flex type_size_16">
							<span class="subject_color">{{ dataInfo.classLevel.name }}</span>
							<el-divider direction="vertical"></el-divider>
							<span>{{ dataInfo.student.name }}</span>
						</div>
					</div>
				</div>
				<div id="" v-if="testShow">
					<div class="type_size_18" style="margin: 20px 60px ;" v-if="dataInfo.question_type != 4 && dataInfo.question_type != 6">
						订正答案：{{ dataInfo.revised_content }}
					</div>
					<div class="type_size_18" style="margin: 20px 60px ;" v-if="dataInfo.question_type == 4 || dataInfo.question_type == 6">
						<div class="p_m_t_20" v-for="(item, i) in dataInfo.revised_content" :key="i">
							<div id="">订正答案：{{ item.text }}</div>
						</div>
					</div>
					<div style="margin: 20px 60px ;">
						<el-image
							v-for="(v, i) in dataInfo.revised_image"
							:key="i"
							style="width: 120px; height: 120px;margin-right: 20px;"
							:src="v"
							:preview-src-list="dataInfo.revised_image"
						></el-image>
					</div>
					<div class="suggest p_m_t_20" v-if="dataInfo.proposal">
						<div class="suggest_box subject_yellow type_size_16">建议：{{ dataInfo.proposal }}</div>
					</div>
					<div class="content_list small_hand" v-if="type == 0">
						<div class="content_box p_b_b p_b_l p_b_t " @click="goSuggest(dataInfo.id)">
							<div class="p_flex p_f_c zi_ti subject_yellow" style="width: 30px; height: 23px;"><img src="../../../assets/img/jianyi.png" /></div>
							<span class="p_flex p_f_c">建议</span>
						</div>
						<div
							class="content_box p_b_l "
							:class="[dataInfo.wrong_correct_status == 1 ? ' p_b_b' : '']"
							v-if="dataInfo.wrong_correct_status != 1"
							@click="mistake(dataInfo.id, 3)"
						>
							<div class="p_flex p_f_c zi_ti"><img src="../../../assets/img/error.png" /></div>
							<span class="p_flex p_f_c">答错</span>
						</div>
						<div class="content_box p_b_b p_b_l p_b_t " v-if="dataInfo.wrong_correct_status != 1" @click="mistake(dataInfo.id, 1)">
							<div class="p_flex p_f_c zi_ti subject_color"><img src="../../../assets/img/right.png" /></div>
							<span class="p_flex p_f_c">答对</span>
						</div>
					</div>
				</div>
				<div id="" v-if="!testShow" style="height: 90%;">
					<view-iform v-if="dataInfo.jobPublish.exercise_book_file_type == 1" :url='dataInfo.jobPublish.exercise_book_file_url'></view-iform>
					<view-iform v-if="dataInfo.jobPublish.exercise_book_file_type == 2" :url=' "https://view.officeapps.live.com/op/view.aspx?src=" + dataInfo.jobPublish.exercise_book_file_url'></view-iform>
					<view-picture v-if="dataInfo.jobPublish.exercise_book_file_type == 3"  :url='dataInfo.jobPublish.exercise_book_file_url'></view-picture>
				</div>
			</div>
			<div class="deatil_list p_m_l_20 overflow" :style="{ height: height - 80 + 'px' }"><detail-list @goDeatils="goDeatils" :type="type"></detail-list></div>
		</div>
		<pop-up ref="popup" :show="show" @closes="closes" @goButton="goButton"></pop-up>
	</div>
</template>

<script>
import DetailList from './commponents/detailList.vue';
import PopUp from './commponents/popUp.vue';
import ViewIform from './commponents/iform.vue'
import ViewPicture from './commponents/picture.vue'
export default {
	name: 'WrongDetails',
	components: {
		DetailList,
		PopUp,
		ViewIform,
		ViewPicture
	},
	data() {
		return {
			type: '0',
			height: 0,
			show: false,
			job_record_id: '',
			dataInfo: {},
			testShow: true
		};
	},
	mounted() {
		this.type = this.$route.query.type;
		this.job_record_id = this.$route.query.job_record_id;
		this.indexInfo();
		this.getInfo();
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/WrongDetails') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},

	methods: {
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		getInfo() {
			this.$request
				.ajax(this)
				.post('/api_teacher/wrong_question_detail', {
					job_record_id: this.job_record_id
				})
				.then(res => {
					console.log(res);
					this.dataInfo = res.data;
				});
		},
		goSuggest(id) {
			this.show = true;
			this.$refs.popup.record(id);
		},
		mistake(id, i) {
			this.$confirm('确认批改吗', '批改', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.piGaiInfo(id, i);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
		},
		piGaiInfo(id, i) {
			this.$request
				.ajax(this)
				.post('/api_teacher/wrong_correction_questions', {
					wrong_correct_status: i,
					job_record_id: id
				})
				.then(res => {
					// this.$message({
					// 	type: 'success',
					// 	message: res.msg
					// });
					this.getInfo();
				});
		},
		// 关闭按钮
		closes(val) {
			this.show = val;
		},
		// 下发作业确认按钮
		goButton(val) {
			this.show = val;
			this.getInfo();
		},
		goDeatils(id) {
			this.job_record_id = id;
			this.getInfo();
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	}
};
</script>

<style lang="scss" scoped>
.deatil_list {
	width: 380px;
	background: #ffffff;
}
.deatil_content {
	position: relative;
	height: 100%;
	background: #ffffff;
}
.list_box {
	padding: 20px 0;

	margin: 0 60px;
}
.content_list {
	position: absolute;
	bottom: 100px;
	right: 0;
}
.content_box {
	padding: 16px;
	font-size: 12px;
}
.zi_ti {
	font-size: 18px;
	margin-bottom: 5px;
}
.suggest {
	padding: 20px;
	margin: 0 60px 0;
	background: #fffaf2;
	opacity: 1;
	border-radius: 20px;
}
.correct >>> .el-divider {
	background-color: #00af63;
}
.correct >>> .el-divider__text {
	color: #00af63;
}
.zi_ti {
	width: 30px;
	height: 30px;
	margin-bottom: 5px;
}
img {
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/wrong/details.vue